// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
//import PolicyHelp from './components/policy/policyHelp'
import router from './router'
import VueCookies from 'vue-cookies'
// import VueLodash from 'vue-lodash' lodash console err로 lodash 사용시 각개 프로젝트 import
import TextHighlight from 'vue-text-highlight';
import Fragment from 'vue-fragment'
//import { RecycleScroller } from 'vue-virtual-scroller'

import Common from "./components/common/Common.js"
import GlobalConstants from './components/common/global.constants.js'
import Profile from './components/common/profile.js'
import UrlsConfig from "../config/urls.conf.js"
import axios from 'axios'
import VueI18n from 'vue-i18n'
import VueAnalytics from 'vue-analytics'
import BootstrapVue from 'bootstrap-vue';

import en from '../static/i18n/en.json'
import ko from '../static/i18n/ko.json'
import zh from '../static/i18n/zh.json'
import ja from '../static/i18n/ja.json'

import * as am4core from "@amcharts/amcharts4/core";

import Toasted from 'vue-toasted'

/* General 컴포넌트 적용 시 바뀔 부분 - Start */
import Amchart from './components/amcharts/index'
/* General 컴포넌트 적용 시 바뀔 부분 - End */

// 로딩 전역 컴포넌트
import DivLoading from './components/common/loading.vue'
import SelectBoxSingle from './components/common/selectBoxSingle.vue'
import SelectBoxMulti from './components/common/selectBoxMulti.vue'
import InputBox from './components/common/inputBox.vue'
import Paginate from 'vuejs-paginate'
am4core.options.commercialLicense = true;
am4core.options.autoDispose = true;

axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.prototype.http = axios
Vue.prototype.Common = Common
Vue.config.productionTip = false
Vue.prototype.urls = UrlsConfig
Vue.prototype.constants = GlobalConstants
Vue.prototype.profile = Profile;

// register globally
Vue.component('text-highlight', TextHighlight)
Vue.component('div-loading', DivLoading)
Vue.component('select-box-single', SelectBoxSingle)
Vue.component('select-box-multi', SelectBoxMulti)
Vue.component('input-box', InputBox)
Vue.component('paginate', Paginate)

//Vue.component('RecycleScroller', RecycleScroller)

Vue.use(BootstrapVue);
Vue.use(Vuex)
Vue.use(Toasted)
Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.use(Fragment.Plugin)
// Vue.use(VueLodash) lodash console err로 lodash 사용시 각개 프로젝트 import
Vue.use(require('vue-moment'));

Vue.use(VueAnalytics, {
    id: 'UA-144371379-2',
    router
})

/* General 컴포넌트 적용 시 바뀔 부분 - Start */
// Amcharts 4
Vue.use(Amchart.AmchartPie) // Pie chart made by amcharts 4
Vue.use(Amchart.AmchartXY) // XY chart made by amcharts 4

/* General 컴포넌트 적용 시 바뀔 부분 - End */

const languages = {
    en: en,
    ko: ko,
    zh: zh,
    ja: ja,
}
let defaultLocale;
if (VueCookies.get(GlobalConstants.LangCode)) {
    defaultLocale = VueCookies.get(GlobalConstants.LangCode);
} else {
    if (navigator.appVersion.indexOf('MSIE') > -1) { // Explorer
        defaultLocale = navigator['userLanguage'].split('-')[0];
    } else {
        if(location.host.indexOf('opsnow.cn') > -1) {
            defaultLocale = GlobalConstants.CHINESE;
        } else {
            defaultLocale = navigator.language.split('-')[0];
        }
    }
}
defaultLocale = /(en|ko|zh|ja)/gi.test(defaultLocale) ? defaultLocale : GlobalConstants.ENGLISH;

const messages = Object.assign(languages)

axios.interceptors.request.use(function(conf) {
    var config = conf;
    let tokenKey = Profile.env==='LOCAL' || Profile.env==='DEV' ? VueCookies.get(GlobalConstants.ACCESS_TOKEN_DEV) : VueCookies.get(GlobalConstants.ACCESS_TOKEN);
    const { excludeToken = false } = config;

    if(tokenKey && !excludeToken && tokenKey !== 'null') {
        config.headers.Authorization = `Bearer ${tokenKey}`;
    }
    else{
        console.log("no TWoken!~!");
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});

axios.interceptors.response.use((response) => {
    return response
}, function (error) {

    console.log(error);

    return Promise.reject(error.response)
});

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: en,
    messages,
    silentTranslationWarn: true // warning message delete
});

const options = {
    position: 'top-center',
    mode: 'override',
    duration: 2000,
    type: 'error'
}

Vue.toasted.register('showMessage',
    (payload) => {
        if (!payload.message) {
            return 'Oops.. Something Went Wrong..'
        }
        return payload.message
    },
    options
)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    components: {App},
    template: '<App/>'
});





// WEBPACK FOOTER //
// ./src/main.js